import CarouselSlider from './carousel-slider'
import loadDaySchedule from './loadDaySchedule'
import loadDayScheduleSliders from './loadDayScheduleSliders'
import moment from 'moment'

export default () => {
	CarouselSlider.init('.carousel--branding', {
		effect: 'fade',
		loop: true,
	})

	CarouselSlider.init('.carousel--promo', {
		allowTouchMove: false,
		on: {
			slideChange: (swiper) => {
				const prevSlide = swiper.slides[swiper.previousIndex]
				const iframe = prevSlide.querySelector('iframe')
				const video = prevSlide.querySelector('video')

				if (iframe) {
					const src = iframe.src
					iframe.src = src
				}
				if (video) {
					video.pause()
				}
			},
		},
	})

	CarouselSlider.init('.carousel--program-date', {
		slidesPerView: 3,
		spaceBetween: 20,
		breakpoints: {
			320: { slidesPerView: 1 },
			560: { slidesPerView: 2 },
			767: { slidesPerView: 3 },
		},
	})

	CarouselSlider.init('.carousel--program-list', {
		slidesPerView: 3,
		spaceBetween: 20,
		// autoHeight: true,
		breakpoints: {
			320: { slidesPerView: 1 },
			560: { slidesPerView: 2 },
			767: { slidesPerView: 3 },
		},
		on: {
			init: function (e) {
				const currentTime = new Date().getHours() * 60 + new Date().getMinutes()
				let slideIndex = 0
				let shouldUpdate = true

				e.slides.forEach((slide, index) => {
					const dataTime = slide.getAttribute('data-time')
					const time = dataTime.match(/\d+/g)
					const slideTime = +time[0] * 60 + +time[1]

					if (currentTime > slideTime && shouldUpdate) {
						slideIndex = index
					} else {
						shouldUpdate = false
					}
				})

				e.slideTo(slideIndex)
			},
		},
	})

	CarouselSlider.init('.carousel--schedule', {
		slidesPerView: 4,
		spaceBetween: 10,
		initialSlide: 7,
		breakpoints: {
			320: { slidesPerView: 1 },
			560: { slidesPerView: 3 },
			767: { slidesPerView: 4 },
		},
	})

	CarouselSlider.init('.carousel--detail', {
		slidesPerView: 3,
		spaceBetween: 20,
		breakpoints: {
			320: { slidesPerView: 1 },
			560: { slidesPerView: 2 },
			767: { slidesPerView: 2 },
		},
	})

	document.querySelectorAll('.js-schedule-date-slide').forEach((el, key) => {
		if (el.dataset.date === moment().subtract('5', 'hour').format('YYYY-MM-DD')) {
			el.classList.add('carousel__item--active')
		}

		el.addEventListener('click', function () {
			document
				.querySelector('.js-schedule-date-slide.carousel__item--active')
				.classList.remove('carousel__item--active')
			el.classList.add('carousel__item--active')

			const date = el.dataset.date
			const slider = el.dataset.slider
			const list = el.dataset.list

			slider && loadDayScheduleSliders(date, slider)
			list && loadDaySchedule(date, list)
		})
	})
}
const program_date = document.querySelector('.carousel--program-date .carousel__container')?.swiper
const program_list = document.querySelector('.carousel--program-list .carousel__container')?.swiper
const schedule = document.querySelector('.carousel--schedule .carousel__container')?.swiper

let i = 1
const timer = setInterval(() => {
	program_date?.update()
	program_list?.update()
	schedule?.update()
	i += 1
	if (i === 20) clearInterval(timer)
}, 100)
